import { render } from "./v-telegram-widget.vue?vue&type=template&id=162d19f4"
import script from "./v-telegram-widget.vue?vue&type=script&lang=js"
export * from "./v-telegram-widget.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/datadrivet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__